import React from 'react';

interface PWAUpdateProps {
    isUpdateAvailable: boolean;
    onUpdate: () => void;
    onDismiss: () => void;
}

const PWAUpdate: React.FC<PWAUpdateProps> = ({ isUpdateAvailable, onUpdate, onDismiss }) => {
    if (!isUpdateAvailable) {
        return null;
    }

    return (
        <div className="pwa-update-banner">
            <div className="pwa-update-content">
                <div className="pwa-update-icon">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                        />
                    </svg>
                </div>
                <div className="pwa-update-text">
                    <h3 className="pwa-update-title">Update Available</h3>
                    <p className="pwa-update-description">
                        A new version of Podus AI is available with bug fixes and improvements.
                    </p>
                </div>
                <div className="pwa-update-actions">
                    <button onClick={onUpdate} className="pwa-update-button pwa-update-button-primary">
                        Update Now
                    </button>
                    <button onClick={onDismiss} className="pwa-update-button pwa-update-button-secondary">
                        Later
                    </button>
                </div>
            </div>

            <style>{`
        .pwa-update-banner {
          position: fixed;
          top: 20px;
          right: 20px;
          background: linear-gradient(135deg, #ff6600 0%, #ff8533 100%);
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          color: white;
          max-width: 380px;
          z-index: 1000;
          animation: slideIn 0.3s ease-out;
        }

        .pwa-update-content {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }

        .pwa-update-icon {
          flex-shrink: 0;
          margin-top: 2px;
        }

        .pwa-update-text {
          flex: 1;
          margin-bottom: 16px;
        }

        .pwa-update-title {
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 4px 0;
          line-height: 1.4;
        }

        .pwa-update-description {
          font-size: 14px;
          margin: 0;
          opacity: 0.9;
          line-height: 1.5;
        }

        .pwa-update-actions {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .pwa-update-button {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          border: none;
          transition: all 0.2s ease;
        }

        .pwa-update-button-primary {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          backdrop-filter: blur(10px);
        }

        .pwa-update-button-primary:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-1px);
        }

        .pwa-update-button-secondary {
          background: transparent;
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        .pwa-update-button-secondary:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @media (max-width: 480px) {
          .pwa-update-banner {
            top: 10px;
            right: 10px;
            left: 10px;
            max-width: none;
            padding: 16px;
          }

          .pwa-update-content {
            flex-direction: column;
            align-items: flex-start;
          }

          .pwa-update-actions {
            width: 100%;
          }

          .pwa-update-button {
            flex: 1;
            justify-content: center;
          }
        }
  `}</style>
        </div>
    );
};

export default PWAUpdate;
